import React from 'react';
import {Skeleton} from '../../../../../../common/components/Skeleton/Skeleton';
import {SkeletonSection} from '../../../../../../common/components/Skeleton/SkeletonSection/SkeletonSection';
import {SkeletonRow} from '../../../../../../common/components/Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonLineWrapper} from '../../../../../../common/components/Skeleton/SkeletonLine/SkeletonLineWrapper';
import {FooterDataHooks} from '../Footer';

export const ExpressButtonsSkeleton = () => {
  return (
    <Skeleton dataHook={FooterDataHooks.expressButtonsSkeleton}>
      <SkeletonSection>
        <SkeletonRow>
          <SkeletonLineWrapper size="xl" />
        </SkeletonRow>
        <SkeletonRow>
          <SkeletonLineWrapper size="xl" />
        </SkeletonRow>
        <SkeletonRow>
          <SkeletonLineWrapper size="xl" />
        </SkeletonRow>
      </SkeletonSection>
    </Skeleton>
  );
};
